import { Controller } from "@hotwired/stimulus"

// Client-side filter for the seniors FAQ accordion. Each item carries a
// `data-search-text` attribute (question + answer, lowercased, entities
// stripped) generated by the view, so JS just does a substring match.
// Non-matching items are hidden via the `hidden` attribute; an empty-state
// message shows when nothing matches.
export default class extends Controller {
  static targets = ["input", "item", "empty"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let matches = 0

    this.itemTargets.forEach(item => {
      const visible = !query || (item.dataset.searchText || "").includes(query)
      item.hidden = !visible
      if (visible) matches++
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.hidden = matches > 0
    }
  }
}
